var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.theme,attrs:{"id":_vm.id}},[_c('span',{staticClass:"prepend-text"},[_vm._v(_vm._s(_vm.label))]),_c('v-select',{attrs:{"value":_vm.defaultValue,"items":_vm.items,"text":"","solo":""},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }